import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import ProductManager from '@/components/v2/inquiry/ProductManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import SearchMixinProp from '@/helpers/vue_mixins/v2/SearchMixinProp';
import CopierDialog from '@/components/v2/CopierDialog.vue';
import CopierMixin from '@/helpers/vue_mixins/v2/CopierMixin';
/**
 * Inquiry Product List View
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let ProductListView = class ProductListView extends Mixins(PhotoMixin, RouterParamsAppMixin, SearchMixinProp, CopierMixin) {
    get headers() {
        return [
            {
                text: 'PHOTO',
                value: 'photo',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Product Name',
                value: 'product',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Description',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'FB ADS PAYLOAD',
                value: 'ads_payload',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SHARE PRODUCT LINK',
                value: 'ref_link',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Published',
                value: 'publish',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Action',
                value: 'action',
                align: 'center',
                sortable: false,
            },
        ];
    }
};
ProductListView = __decorate([
    Component({
        components: {
            ActionButton,
            ProductManager,
            CopierDialog,
        },
    })
], ProductListView);
export default ProductListView;
